import React, { Component } from "react";
import L from "leaflet";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import "./leaflet.css";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { calculateCircularDomainPolygons, calculateRotatedDomainPolygon } from "../domain-utils";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

class SelectMap extends Component {
    state = {
        lat: 0,
        lon: 0,
    }

    setLat = (val) => {
        this.setState({ lat: val })
    }

    setLon = (val) => {
        this.setState({ lon: val })
    }

    plotItems = () => {
        const { domains, colors, activeDomainIndex } = this.props;
        this.drawnItems.clearLayers();

        domains.forEach((domain, index) => {
            if (domain.icontools.region_type === 3) {
                if (domain.icontools.lrotate) {
                    // add domain
                    L.polygon(calculateRotatedDomainPolygon(
                        parseFloat(domain.icontools.center_lat),
                        parseFloat(domain.icontools.center_lon),
                        parseFloat(domain.icontools.hwidth_lat),
                        parseFloat(domain.icontools.hwidth_lon),
                        parseFloat(domain.icontools.pole_lat),
                        parseFloat(domain.icontools.pole_lon),
                        true,
                        true,
                    ), {
                        color: index <= colors.length - 1 ? colors[index] : colors[index - colors.length],
                        weight: activeDomainIndex === index ? 3 : 0.8,
                        fillOpacity: activeDomainIndex === index ? 0.5 : 0.2
                    }
                    ).addTo(this.drawnItems);

                    // add pole
                    L.circleMarker(
                        [
                            !isNaN(domain.icontools.pole_lat) ? domain.icontools.pole_lat : 90,
                            !isNaN(domain.icontools.pole_lon) ? domain.icontools.pole_lon : -180
                        ],
                        { radius: 3, color: colors[index] }
                    ).addTo(this.drawnItems);

                } else {
                    const minLat = domain.icontools.center_lat - domain.icontools.hwidth_lat;
                    const minLon = domain.icontools.center_lon - domain.icontools.hwidth_lon;
                    const maxLat = parseFloat(domain.icontools.center_lat) + parseFloat(domain.icontools.hwidth_lat);
                    const maxLon = parseFloat(domain.icontools.center_lon) + parseFloat(domain.icontools.hwidth_lon);

                    L.rectangle(
                        L.latLngBounds([
                            [minLat, minLon],
                            [maxLat, maxLon],
                        ]),
                        {
                            color: index <= colors.length - 1 ? colors[index] : colors[index - colors.length],
                            weight: activeDomainIndex === index ? 3 : 0.8,
                            fillOpacity: activeDomainIndex === index ? 0.5 : 0.2
                        }
                    ).addTo(this.drawnItems);
                }
            } else if (domain.icontools.region_type === 2) {

                // add domain
                L.polygon(calculateCircularDomainPolygons(
                    parseFloat(domain.icontools.center_lat),
                    parseFloat(domain.icontools.center_lon),
                    parseFloat(domain.icontools.radius),
                    true,
                    true
                ), {
                    color: index <= colors.length - 1 ? colors[index] : colors[index - colors.length],
                    weight: activeDomainIndex === index ? 3 : 0.8,
                    fillOpacity: activeDomainIndex === index ? 0.5 : 0.2
                }
                ).addTo(this.drawnItems);

                // add pole
                L.circleMarker(
                    [
                        !isNaN(domain.icontools.pole_lat) ? domain.icontools.pole_lat : 90,
                        !isNaN(domain.icontools.pole_lon) ? domain.icontools.pole_lon : -180
                    ],
                    { radius: 3, color: colors[index] }
                ).addTo(this.drawnItems);

                return this.drawnItems
            }
        });
    };

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            const { domains, activeDomainIndex } = this.props;
            this.plotItems();

            this.map.panTo([domains[activeDomainIndex].icontools.center_lat ?? 49.5, domains[activeDomainIndex].icontools.center_lon ?? 11.5]);
        }
    }

    async componentDidMount() {
        const { domains, activeDomainIndex } = this.props;
        this.map = L.map("map", {
            preferCanvas: true,
            center: [domains[activeDomainIndex].icontools.center_lat ?? 49.5, domains[activeDomainIndex].icontools.center_lon ?? 11.5],
            zoom: 3,
            minZoom: 2,
            maxZoom: 17,
            showCursorLocation: true,
            zoomAnimation: true,
            cursor: true,
            autoPan: false,
            layers: [
                new L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
                    maxZoom: 19,
                    attribution:
                        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                })
            ]
        });

        this.map.addEventListener('mousemove', (event) => {
            this.lat = parseFloat(event.latlng.lat).toFixed(4);
            this.lon = parseFloat(event.latlng.lng).toFixed(4);

            this.setLat(this.lat);
            this.setLon(this.lon);
        })
        this.map.doubleClickZoom.disable();
        this.drawnItems = new L.FeatureGroup();
        this.map.addLayer(this.drawnItems);
        this.plotItems();
    }

    render() {
        return (
            <React.Fragment>
                <div id="map" className="leaflet-map" />
                <p className="leaflet-coords">LatLon({this.state.lat} / {this.state.lon})</p>
            </React.Fragment>
        );
    }
}

export default SelectMap;
